import React, { useEffect, useRef } from 'react';
import useCameraPreviewFrame from '../../../hooks/useCameraPreviewFrame';
import { dedupeClosingPoints, resolveFramePoints } from '../../../utils/polygon';

/**
 * CR-UX02 (ТЗ 28/29): read-only кадр камеры с предложенным контуром для
 * администратора, разбирающего заявку. Координаты — пиксели original-кадра
 * (то же пространство, что у Zone Editor): canvas получает natural-размер
 * картинки, CSS масштабирует без искажения пропорций. Сам кадр — из того же
 * слоя useCameraPreviewFrame, что и Zone Editor (B1).
 */
const drawPolygon = (ctx, points, stroke, fill) => {
  // Sentinel «весь кадр» (отрицательные координаты) разворачивается по
  // размеру канваса — иначе существующая зона на кадре не видна.
  const pts = resolveFramePoints(dedupeClosingPoints(points), ctx.canvas.width, ctx.canvas.height);
  if (pts.length < 2) return;
  ctx.beginPath();
  ctx.moveTo(pts[0][0], pts[0][1]);
  pts.slice(1).forEach(([x, y]) => ctx.lineTo(x, y));
  if (pts.length > 2) ctx.closePath();
  ctx.lineWidth = 3;
  ctx.strokeStyle = stroke;
  ctx.stroke();
  if (pts.length > 2) { ctx.fillStyle = fill; ctx.fill(); }
};

const ZonePolygonPreview = ({ cameraId, polygon = [], existingZones = [] }) => {
  const imageRef = useRef(null);
  const canvasRef = useRef(null);
  const { phase, url: frameUrl, reload } = useCameraPreviewFrame(cameraId);

  const draw = () => {
    const image = imageRef.current;
    const canvas = canvasRef.current;
    if (!image || !canvas || !image.naturalWidth) return;
    canvas.width = image.naturalWidth;
    canvas.height = image.naturalHeight;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(image, 0, 0);
    existingZones.forEach((zone) => drawPolygon(ctx, zone?.polygon || [], 'rgba(120,120,120,0.9)', 'rgba(120,120,120,0.15)'));
    drawPolygon(ctx, polygon, '#d9480f', 'rgba(217,72,15,0.25)');
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(draw, [polygon, existingZones, frameUrl]);

  if (phase === 'loading') return <p className="vio-field-hint">Загружаем кадр…</p>;
  if (phase === 'error') {
    return (
      <p className="vio-field-hint vio-field-hint--warning">
        Не удалось загрузить кадр камеры.{' '}
        <button type="button" className="vio-btn vio-btn--link" onClick={reload}>Повторить</button>
      </p>
    );
  }
  if (phase !== 'ready') return <p className="vio-field-hint vio-field-hint--warning">Кадров камеры нет — контур показать не на чем.</p>;

  return (
    <div className="vio-zone-canvas">
      <img ref={imageRef} src={frameUrl} alt="Кадр камеры" onLoad={draw} style={{ display: 'none' }} />
      <canvas ref={canvasRef} />
    </div>
  );
};

export default ZonePolygonPreview;
